(function ($) {

    $(document).on('ready', function(){
        var iFrame = $('#events-video__modal iframe');
        var modal = $('#events-video__modal');
        var modalBody = $('#events-video__modal .modal-body');
        var modalDialog = $('#events-video__modal .modal-dialog');
        var playBtn = $('.events-video__play-btn');

        playBtn.on('click', function(){
            modal.modal('show');
        });

        modal.on("hidden.bs.modal", function() {
            iFrame.attr("src", iFrame.attr("src"));
        });

        modal.on("show.bs.modal", function() {
            // modal.css('padding-right', 0)
            // $('body').css('padding-right', 0);
        });
 
        modal.on("shown.bs.modal", function() {
            // modal.css('padding-right', 0)
            // $('body').css('padding-right', 0);
            middle({animate: true});
        });

        var $window = $(window);
        $window.on('resize', function(){
            middle();
        });

        function middle(options){
            options = options || {};
            var newTop = $window.height() / 2 - (modalBody.height() / 2);
            if (options.animate){
                modalDialog.animate({
                    top: newTop
                });
            } else {
                modalDialog.css('top', newTop);
            }

        }
    });

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/events.js